export default __webpack_public_path__ + "static/media/twitterWhite.59e154f4.svg";